import { heroLead, heroSide } from '../data';

export default function Hero() {
  return (
    <section id="top" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-col gap-3 border-l-4 border-primary-500 pl-4">
          <p className="flex flex-wrap items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            <span className="rounded bg-primary-100 px-2 py-0.5 text-primary-700">今日看瓜 · 今日热点</span>
            <span className="text-foreground-500">每天第一口瓜，从这里开始</span>
          </p>
          <p className="text-sm leading-relaxed text-foreground-600 md:max-w-3xl">
            实时更新的热点榜把分散在各平台的瓜聚到一起，最新动态不遗漏，快速判断当前最值得关注的事件。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-5">
          <a
            href="#special"
            className="group relative flex min-h-[340px] flex-col justify-end overflow-hidden rounded-2xl md:min-h-[440px] lg:col-span-2 lg:min-h-[480px]"
          >
            <img
              src={heroLead.img}
              alt={heroLead.title}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/10"></div>
            <div className="relative p-5 text-background-50 md:p-7">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold">
                <i className="ri-flashlight-line"></i>
                {heroLead.kicker}
              </span>
              <span className="ml-2 inline-flex items-center rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-semibold backdrop-blur-sm">
                {heroLead.tag}
              </span>
              <h1 className="font-heading mt-3 text-2xl font-bold leading-snug text-background-50 md:text-4xl">
                {heroLead.title}
              </h1>
              <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-50/90 md:text-base">
                {heroLead.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-semibold text-primary-600 transition-colors group-hover:bg-primary-50">
                看这口瓜怎么聊
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>

          <div className="flex flex-col gap-4 lg:gap-5">
            {heroSide.map((item) => (
              <a
                key={item.title}
                href="#feed"
                className="group relative flex min-h-[150px] flex-1 flex-col justify-end overflow-hidden rounded-2xl md:min-h-[210px]"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-black/5"></div>
                <div className="relative p-4 text-background-50 md:p-5">
                  <h3 className="font-heading text-base font-bold leading-snug md:text-lg">{item.title}</h3>
                  <p className="mt-1 line-clamp-1 text-xs text-background-50/85 md:text-sm">{item.desc}</p>
                  <span className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-background-50/90">
                    进入快讯流
                    <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}